import {
  ColorField as ColorFieldBase,
  type ColorFieldProps as ColorFieldBaseProps,
  FieldError,
  Group,
  Input,
  Label,
  parseColor,
  Text,
} from "react-aria-components";
import type { ReactNode } from "react";
import { css, cx } from "../../../../styled-system/css";
import type { SystemStyleObject } from "../../../../styled-system/types";
import { formField, type FormFieldVariant } from "../../../../styled-system/recipes";
import { ColorPicker } from "./ColorPicker";

interface ColorFieldProps extends Omit<ColorFieldBaseProps, "value" | "defaultValue" | "onChange" | "children"> {
  value: string | null;
  onChange: (value: string | null) => void;

  label?: ReactNode;
  description?: string;
  errorMessage?: string;
  placeholder?: string;

  css?: SystemStyleObject;
  variant?: FormFieldVariant["variant"];
}

export function ColorField({
  value,
  onChange,
  label,
  description,
  errorMessage,
  placeholder,
  css: cssProp,
  variant,
  ...props
}: ColorFieldProps) {
  const classes = formField({ variant });
  return (
    <ColorFieldBase
      isInvalid={!!errorMessage}
      {...props}
      value={value ? parseColor(value) : null}
      onChange={(color) => onChange(color?.toString("hex") ?? null)}
      className={cx(classes.fieldWrapper, css(cssProp))}
    >
      {label && <Label className={classes.label}>{label}</Label>}
      <Group className={classes.inputBox}>
        <ColorPicker value={value} onChange={onChange} />
        <Input className={classes.input} placeholder={placeholder} />
      </Group>
      {description && <Text slot="description">{description}</Text>}
      {errorMessage && <FieldError className={classes.error}>{errorMessage}</FieldError>}
    </ColorFieldBase>
  );
}
